import { Directive, ElementRef } from '@angular/core';
import { fromEvent } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Directive({
  selector: '[floatingLabel]'
})
export class FloatingLabeldDirective {
  private elr: ElementRef;
  private subscriptions: any = {};

  constructor(el: ElementRef) {
    this.elr = el;
  }

  ngOnInit() {
    this.elr.nativeElement.onclick = () => {
      this.elr.nativeElement.previousSibling.focus();
    };

    this.subscriptions.inputChange = fromEvent(this.elr.nativeElement.ownerDocument, 'loaded')
      .pipe(debounceTime(10))
      .subscribe(evt => {
        this.elr.nativeElement.previousSibling.focus();
      });
  }

  ngAfterViewInit() {
  }

  ngOnDestroy() {
    Object.keys(this.subscriptions).forEach((key) => {
      this.subscriptions[key].unsubscribe();
    });
  }
}
